<template>
  <div>
    <div v-if="showNotice" ref="dialog" :class="componentClassName" :style="style">
      <a-notice-header
        :exist-new="isExistNew(noticeList)"
        :icon="iconMinimize"
        :icon-color="titleIconColor"
        class="o-notice__header"
        @mode="viewMode"
      >
        <slot name="title">お知らせ</slot>
      </a-notice-header>
      <div class="o-notice__body">
        <template v-for="(object, index) in noticeList" :key="index">
          <div @click="setNotifyMessageViewed(object)">
            <a-notice-list-item
              size="small"
              :important="object.importantFlag"
              :label="object.text"
              :new-flag="object.newFlag"
              :sublabel="object.updateDate"
              :url="object.url"
              opwindow="true"
            />
          </div>
        </template>
      </div>
    </div>
    <div v-if="!showNotice" ref="dialog" :class="componentClassName" style="width: 216px; height: 35px">
      <a-notice-header
        :exist-new="isExistNew(noticeList)"
        :icon="iconFullscreen"
        :icon-color="titleIconColor"
        class="o-notice__header"
        @mode="viewMode"
      >
        <slot name="title">お知らせ</slot>
      </a-notice-header>
    </div>

    <teleport to="body">
      <o-modal
        id="notice_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="close-modal-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ANoticeHeader from '@/components/atoms/notice-header';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
export default {
  name: 'o-notice',
  components: {
    ANoticeHeader,
  },
  mixins: [messageContent, customRequest],
  props: {
    title: {
      type: String,
      default: '',
    },
    iconMinimize: {
      type: String,
      default: 'minimize',
    },
    iconFullscreen: {
      type: String,
      default: 'fullscreen',
    },
    titleIconColor: {
      type: String,
      default: 'white',
    },
    width: {
      type: String,
      default: '500px',
    },
    height: {
      type: String,
      default: '500px',
    },
    class: {
      type: String,
      default: '',
    },
    noticeList: {
      type: Object,
      default: null,
    },
  },
  emits: ['mode'],
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      showNotice: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-notice');
      return `${baseClassName}`.trim();
    },
    style() {
      const style = {};
      if (this.width) {
        style.width = this.width;
      }
      if (this.height) {
        style.height = this.height;
      }
      return style;
    },
  },
  created() {
    //#4057 commentout
    //this.getNoticeListViewFlag();
  },
  methods: {
    viewMode() {
      this.setNoticeListViewFlag();
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    getNoticeListViewFlag: async function () {
      await this.postRequest('/notice/getNoticeListViewFlag')
        .then(data => {
          let ret = true;
          if (data.status === 'success') {
            ret = data.flag;
          }
          this.showNotice = ret;
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
        });
    },
    setNoticeListViewFlag: async function () {
      this.showNotice = !this.showNotice;
      await this.postRequest('/notice/setNoticeListViewFlag', { flag: this.showNotice })
        .then(data => {
          if (data.status !== 'success') {
            this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
        });
    },
    isExistNew(list) {
      let ret = false;
      list.forEach(element => {
        if (element.newFlag) {
          ret = true;
        }
      });
      return ret;
    },
    async setNotifyMessageViewed(object) {
      if (!object.newFlag) return;
      await this.postRequest('/notice/setNotifyMessageViewed', { id: object.id })
        .then(data => {
          if (data.status === 'success') {
            object.newFlag = false;
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
        });
    },
  },
};
</script>
